import script from "./CustomButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomButton.vue?vue&type=script&setup=true&lang=ts"

import "./CustomButton.vue?vue&type=style&index=0&id=321d5c9e&lang=less"

const __exports__ = script;

export default __exports__